/**
 * Central, DRY config for the portfolio analytics tracker.
 *
 * The hardcoded values below are the public, write-only ingest credentials for
 * THIS app ("agentic-school") in the central Portfolio Analytics dashboard. The
 * ingest key is public by design (like a Plausible/GA measurement id): it can
 * only APPEND events, never read analytics, so it is safe to ship in client HTML
 * and commit. They are kept as fallbacks so production works even if the
 * `VITE_ANALYTICS_*` env vars are not set on the host; setting the env vars
 * (see `.env.local` / `.env.example`) overrides them per environment.
 *
 * This is the single source of truth - the script injector, the Clerk identify
 * component and the tests all read from here, so rotating the key or pointing at
 * a different ingest deployment is a one-line change.
 */

export const ANALYTICS_SRC =
  import.meta.env.VITE_ANALYTICS_SRC ??
  'https://clerk-user-dashboard.vercel.app/a.js'

export const ANALYTICS_KEY =
  import.meta.env.VITE_ANALYTICS_KEY ?? 'ik_Y5sLEVimIFTm2LPTN6Bx7ebbneBZSKFZ'

export const ANALYTICS_INGEST_URL =
  import.meta.env.VITE_ANALYTICS_INGEST_URL ??
  'https://fleet-pig-422.eu-west-1.convex.site/ingest'

export const ANALYTICS_APP_ID = 'agentic-school'
